











































































import { Vue, Component } from "vue-property-decorator";
import { load } from "recaptcha-v3";

interface IReCAPTCHAResult {
  success: boolean;
  challenge_ts: string;
  hostname: string;
  "error-codes": [];
}

@Component({})
export default class Contact extends Vue {
  private name: string = "";
  private email: string = "";
  private content: string = "";
  private result: IReCAPTCHAResult = {
    success: false,
    challenge_ts: "",
    hostname: "",
    "error-codes": []
  };

  private captcha_site_key: string = process.env.VUE_APP_CAPTCHA_SITE_KEY!;
  private recaptcha_action = "homepage";

  get nameIsValid() {
    return this.name.length > 0 && this.name.length <= 30 ? true : false;
  }
  get emailIsValid() {
    const pattern: RegExp = /^[^\s]+@[^\s]+$/;
    return this.email.match(pattern) ? true : false;
  }
  get contentIsValid() {
    return this.content.length > 0 && this.content.length <= 1000 ? true : false;
  }

  async asyncFunction() {
    const recaptcha = await load(this.captcha_site_key);
    const token = await recaptcha.execute(this.recaptcha_action);
    return token;
  }

  async my_submit() {
    if (this.nameIsValid && this.emailIsValid && this.contentIsValid) {
      const inquiry_body = JSON.stringify({
        name: this.name,
        email: this.email,
        content: this.content,
        token: await this.asyncFunction()
      });
      const headers = { "Content-Type": "application/json" };
      const params: RequestInit = {
        method: "POST",
        mode: "cors",
        headers: headers,
        body: inquiry_body
      };
      const endpoint = process.env.VUE_APP_BACKEND_URL! + "inquiry";
      fetch(endpoint, params)
        .then(response => {
          if (response.ok) {
            return response.blob();
          }
          throw new Error("Network error");
        })
        .then(myBlob => {
          // 成功時の処理
          this.$bvModal.show("modal-2");
          this.clearContents();
        })
        .catch(error => {
          // 失敗時の処理
          this.$bvModal.show("modal-3");
        });
    }
  }
  clearContents() {
    this.name = "";
    this.email = "";
    this.content = "";
  }
}
